import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OvertimeManagementListService {
    private driverOvertimes = new Subject<any>();
    driverOvertimes$ = this.driverOvertimes.asObservable();

    constructor() { }

    updateDriverOvertimes(driverOvertimes: any) {
        this.driverOvertimes.next(driverOvertimes);
    }
}
